import { useNotification } from 'components/Notification'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateCustomerAuthorization } from 'services/customerAuthorizations'
import { createMutationErrorHandler } from 'utils/notifications'

const useChangeScopeMutation = ({ queryKey }) => {
  const { createNotification } = useNotification()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, scope }) => updateCustomerAuthorization(id, { scope }),
    onSuccess: () => {
      createNotification({ message: 'User scope updated', variant: 'success' })
      queryClient.invalidateQueries({ queryKey })
    },
    onError: createMutationErrorHandler(createNotification),
  })
}

export default useChangeScopeMutation
